export const EMAIL_TEMPLATE_LOAD_SUCCESS = 'EMAIL_TEMPLATE_LOAD_SUCCESS';
export const EMAIL_TEMPLATE_UPDATE_SUCCESS = 'EMAIL_TEMPLATE_UPDATE_SUCCESS';
export const EMAIL_TEMPLATE_CREATE_SUCCESS = 'EMAIL_TEMPLATE_CREATE_SUCCESS';